import { render, staticRenderFns } from "./StartupsTable.vue?vue&type=template&id=4915fffd&scoped=true"
import script from "./StartupsTable.vue?vue&type=script&lang=js"
export * from "./StartupsTable.vue?vue&type=script&lang=js"
import style0 from "./StartupsTable.vue?vue&type=style&index=0&id=4915fffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915fffd",
  null
  
)

export default component.exports